import React, { CSSProperties } from 'react';
import classes from './RoundContainer.module.css';
import clsx from 'clsx';
import { COLORS } from 'shared/const/theme';

type RoundContainerProps = {
  children: React.ReactNode;
  size?: number;
  id?: string;
  padding?: number;
  color?: string;
  pointer?: boolean;
  onClick?: () => unknown;
};

const RoundContainer: React.FC<RoundContainerProps> = ({
  children,
  size,
  id,
  padding,
  color,
  pointer,
  onClick,
}) => {
  const styles: CSSProperties = {};
  styles.width = size || 'min-content';
  styles.height = size || 'min-content';

  if (padding) {
    styles.padding = padding;
  }

  styles.backgroundColor = color || 'transparent';

  return (
    <div
      id={id}
      className={clsx(classes.wrapper, pointer ? classes.pointer : '')}
      style={styles}
      onClick={onClick}>
      {children}
    </div>
  );
};

export default RoundContainer;
